import {AuswahlEnum} from '../v2024';

export const AuswahlEnumLabels = {
    _1: '1' as AuswahlEnum,
    _2: '2' as AuswahlEnum
};

